module.exports = __webpack_public_path__ + "img/verified.95f896c9.png";